var _path, _path2, _path3, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavigationMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 18.253C2.11214 18.253 2 18.1409 2 18.003C2 17.8651 2.11214 17.753 2.25 17.753H21.75C21.8879 17.753 22 17.8651 22 18.003C22 18.1409 21.8879 18.253 21.75 18.253H2.25Z",
    fill: "#320E3B",
    stroke: "#582483"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 12.253C2.11214 12.253 2 12.1409 2 12.003C2 11.8651 2.11214 11.753 2.25 11.753H21.75C21.8879 11.753 22 11.8651 22 12.003C22 12.1409 21.8879 12.253 21.75 12.253H2.25Z",
    fill: "#320E3B",
    stroke: "#582483"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 6.25301C2.11214 6.25301 2 6.14086 2 6.00301C2 5.86515 2.11214 5.75301 2.25 5.75301H21.75C21.8879 5.75301 22 5.86515 22 6.00301C22 6.14086 21.8879 6.25301 21.75 6.25301H2.25Z",
    fill: "#320E3B",
    stroke: "#582483"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5.5,
    width: 20,
    height: 1,
    rx: 0.5,
    fill: "#320E3B",
    stroke: "#582483"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 11.5,
    width: 20,
    height: 1,
    rx: 0.5,
    fill: "#320E3B",
    stroke: "#582483"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 17.5,
    width: 20,
    height: 1,
    rx: 0.5,
    fill: "#320E3B",
    stroke: "#582483"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationMenu);
export default __webpack_public_path__ + "static/media/navigation-menu.7d8bbf56b049793037f10cd11ea7a654.svg";
export { ForwardRef as ReactComponent };